
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/dienstleistungen/test-equipment-modernization",
      function () {
        return require("private-next-pages/[locale]/dienstleistungen/test-equipment-modernization.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/dienstleistungen/test-equipment-modernization"])
      });
    }
  